import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getRelationships } from "../../slices/codeBookSlice";

export const useGetRelationships = () => {
  const relationships = useSelector(
    (state: RootState) => state.codeBook.relationships
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRelationships());
  }, [dispatch]);

  return relationships;
};
